module.exports = __webpack_public_path__ + "static/learn1-c1160c1bbdde675a0c594b3ae8c104cb.jpeg";